export default "__VITE_ASSET__fD7Xgfsh__"